import React from 'react';
import { useWatchHasError, useWatchSubmitting, useFormContext, useWatchField } from '@cvent/carina/components/Forms';
import { Button } from '@cvent/carina/components/Button';
import { LoadingIcon } from '@cvent/carina/components/LoadingIcon';

type SubmitButtonProps = {
  testID: string;
  text?: string;
};

const useWatchHasEmpty = (fields): boolean => {
  const trackedFields = useWatchField(fields);

  return Object.values(trackedFields).some(value => value === '');
};

export const SubmitButton = ({ testID, text = 'Submit' }: SubmitButtonProps): JSX.Element => {
  const { getAllValues } = useFormContext();
  const hasError = useWatchHasError();
  const submitting = useWatchSubmitting();
  const hasEmpty = useWatchHasEmpty(Object.keys(getAllValues()));

  return (
    <Button
      testID={`${testID}_button`}
      text={text}
      size={'l'}
      disabled={hasError || hasEmpty || submitting}
      icon={submitting ? LoadingIcon : null}
      type={submitting ? 'button' : 'submit'}
      appearance="filled"
      isBlock
    />
  );
};

export default SubmitButton;
